
import { ABTHelper } from '@tencent/wphk-components-abt';
import { biHottag } from '@tencent/ppd-base-libs';
import { isValidDate } from '@/util/dateHelper';
import { biHT } from '@/business/bi';
let abtHelper: ABTHelper;
let TestID: string;

// abt实验开始时间
const abtStartTime = '2022/06/27 00:00:00';
// abt实验结束时间
const abtEndTime = '2022/07/05 23:59:59';

// 实验组匹配规则
const abtestGroupConfig = [{
  start: '2022/06/27 00:00:00',
  end: '2022/07/05 23:59:59',
  groupData: [{
    group: 'a',
    abtestID: ['127081'],
  }],
}];

/**
 * 获取当前时间段实验配置组信息
 */
export function getAbtestGroup() {
  const result = abtestGroupConfig.find(item => isValidDate(new Date(item.start), new Date(item.end)));
  return result ? result.groupData : null;
}

/**
 * 是否在实验中
 */
export const isInABTTime = () => {
  const start = new Date(abtStartTime);
  const end = new Date(abtEndTime);
  return isValidDate(start, end);
};

/**
 * 实验初始化
 */
export const init = async () => {
  if (!isInABTTime()) return;
  abtHelper = new ABTHelper({ abtModuleSet: 'promozone_specialoffer_1' });
  const isInit = await abtHelper.initABTInfo();
  if (!isInit) {
    console.log('====init fail');
  }
  TestID = abtHelper.getAbtLabelId();
};

export const biHTWithABT = (stat: string, ext?: {}) => {
  if (!isInABTTime()) {
    return biHT(stat, ext);
  };
  if (abtHelper?.abtInfoForBI) {
    abtHelper.abtInfoForBI.biHT(stat, ext);
  } else {
    biHottag(stat, ext);
  }
};

/**
 * 获取实验ID
 */
export function getTestID() {
  return TestID;
}
